/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

class E{static getCookie(k){let B=`; ${document.cookie}`.split(`; ${k}=`);if(B.length===2)return B.pop()?.split(";").shift()??null;return null}static setCookie(k,z,B){let C=new Date;C.setTime(C.getTime()+B*24*60*60*1000);let F="expires="+C.toUTCString();document.cookie=k+"="+z+";"+F+";path=/"}static getQueryParam(k){let z=window.location.search,C=new URLSearchParams(z).get(k);if(!C||C===""||C.length<10)return null;return C}static getSubdomainIndex(){let z=window.location.hostname.split(".");if(z.length===1)return 0;return z.length===2?1:2}static async getIPAddress(){try{let B=(await(await fetch("https://www.cloudflare.com/cdn-cgi/trace")).text()).split("\n").find((F)=>F.startsWith("ip="));if(!B)return null;return B.replace("ip=","")}catch(k){return(await(await fetch("https://api64.ipify.org?format=json")).json()).ip}}}class G{constructor(){let k=E.getCookie("_fbp"),z=E.getCookie("_fbc");if(z?.endsWith("fbclid"))z=null;let B=E.getQueryParam("fbclid"),C=E.getSubdomainIndex();if(!k&&B)k=`fb.${C}.${Date.now()}.${Date.now()}`,E.setCookie("_fbp",k,90);if(!z&&B)z=`fb.${C}.${Date.now()}.${B}`,E.setCookie("_fbc",z,90);console.log("ThirdbasePixel initialized")}getCookies(){return{fbp:E.getCookie("_fbp"),fbc:E.getCookie("_fbc"),fbclid:E.getQueryParam("fbclid")}}getContext(k){if(k.context)return{navigator:{cookieEnabled:k.context.navigator.cookieEnabled,userAgent:k.context.navigator.userAgent,language:k.context.navigator.language},document:{title:k.context.document.title,referrer:k.context.document.referrer,characterSet:k.context.document.characterSet},window:{innerWidth:k.context.window.innerWidth,innerHeight:k.context.window.innerHeight,outerHeight:k.context.window.outerHeight,outerWidth:k.context.window.outerWidth,location:k.context.window.location}};return{navigator:{cookieEnabled:navigator.cookieEnabled,userAgent:navigator.userAgent,language:navigator.language},document:{title:document.title,referrer:document.referrer,characterSet:document.characterSet},window:{innerWidth:window.innerWidth,innerHeight:window.innerHeight,outerHeight:window.outerHeight,outerWidth:window.outerWidth,location:window.location}}}createPayload(k,z){return{id:z.id,name:k,data:z.data,context:this.getContext(z),timestamp:z.timestamp,clientId:z.clientId,type:z.type}}async send(k,z){let C={event:this.createPayload(k,z),cookies:this.getCookies(),ip:await E.getIPAddress()};await fetch("https://services.thirdbase.app/shopify/events",{method:"POST",keepalive:!0,priority:"high",headers:{"Content-Type":"application/json"},body:JSON.stringify(C)})}}

window.ThirdbaseWebPixel =new G;
  
function getLocalStorage(key) {
  const value = localStorage.getItem(key);
  return value ? value : null; // Return the value as a string
}

function sendBeginCheckoutEvent() {
  let checkoutCart = getLocalStorage("checkout-cart");

  // Initialize cartItems
  let cartItems = {};

  // Attempt to parse the JSON string into an object
  try {
    cartItems = JSON.parse(checkoutCart);
  } catch (e) {
    console.error("Invalid JSON in localStorage: ", e);
    return; // Exit if parsing fails
  }

  if (!cartItems?.items) return;

  const event = {
    checkout: {
      token: cartItems.token,
      currencyCode: cartItems.currency || "INR",
      totalPrice: {
        amount: (cartItems.original_total_price || 0) / 100,
        currency: cartItems.currency || "INR",
      },
      subtotalPrice: {
        amount: (cartItems.items_subtotal_price || 0) / 100,
        currency: cartItems.currency || "INR",
      },
      discountsAmount: {
        amount: (cartItems.total_discount || 0) / 100,
        currency: cartItems.currency || "INR",
      },
      lineItems: (Array.isArray(cartItems.items) ? cartItems.items : []).map(
        (item) => ({
          quantity: item.quantity,
          variant: {
            product: {
              id: item.product_id,
              title: item.product_title,
              type: item.product_type,
            },
          },
        })
      ),
    },
  };

  if (typeof window.handleFloCheckoutBtn == "function") {
    Shopify.analytics.publish("shopflo_checkout_initiated", event);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  let header = document.querySelector(".brand-directory-header");
  let content = document.querySelector(".brand-directory-content");

  header.addEventListener("click", function () {
    this.classList.toggle("active");
    if (content.style.height === "auto") {
      content.style.height = "0";
    } else {
      content.style.height = "auto";
    }
  });

  window.dataLayer = window.dataLayer || [];

  const orig = window.dataLayer.push;

  window.dataLayer.push = function (args) {
    if (args[0] == "event" && args[1] == 'begin_checkout') {
        sendBeginCheckoutEvent();
    }

    return orig.apply(window.dataLayer, args);
  };
});
